import axios from "axios";
import Global from "./Global";

const instance = axios.create({
  baseURL: Global.apiUrl,
});

export default instance;
